import { Navbar } from './components/navbar';
import { Home } from './components/home';
import { About } from './components/about';
import { Contact } from './components/contact';
import { Portfolio } from './components/portfolio';
import { Certifications } from './components/certifications';
import './App.css'
import { useState, useEffect } from 'react';
import { Welcome } from './components/welcome';

function App() {
  const [navComNo, setNavComNo] = useState(0);
  const [showWelcome, setShowWelcome] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  const handleNavItemClick = (index) => {
    setNavComNo(index);
  };
  let componentToRender;

  switch (navComNo) {
    case 0:
      componentToRender = <Home />;
      break;
    case 1:
      componentToRender = <About />;
      break;
    case 2:
      componentToRender = <Portfolio />;
      break;
    case 3:
      componentToRender = <Contact />;
      break;
    case 4:
      componentToRender = <Certifications />;
      break;
    default:
      componentToRender = null;
  }

  return (
    <div className="App">
      {showWelcome ? <Welcome /> : (
        <>
          <Navbar onNavItemClick={handleNavItemClick} />
          {componentToRender}
        </>
      )}
    </div>
  );
}

export default App;
